import { styled, Typography } from "@mui/material";
import { TEXT_ELLIPSIS } from "../../../../Shared/styles";

export const TEXT_STYLE = {
    fontSize: "14px",
    fontWeight: 500,
    color: "var(--community-color-primary-text)",
    whiteSpace: "nowrap",
};

export const LIMITED_WIDTH = {
    ...TEXT_ELLIPSIS,
    maxWidth: "calc(50vw - 90px)",
};

export const TimelineItemTitle = styled(Typography)({
    ...TEXT_STYLE,
    ...LIMITED_WIDTH,
    minWidth: "24px",
    textAlign: "center",
});
